module.exports = __webpack_public_path__ + "img/es.9336c619.svg";